const PersonalData = {
    firstName: "Daniel",
    lastName: "Wang",
    nickName:"<  Doctor Dan >",
    mobNo:"+1 647-974-1857",
    email:"danw.ca@gmail.com",
    address:"Canada",
    aboutMe:"Hi Everyone, I am Daneil Wang from Toronto, Canada. Worked with libraries & frameworks like ReactJS, NodeJS. Have a keen knowledge of databases like MySQL, MongoDB and Firebase. Eager to contribute to innovative projects and gain hands-on experience in a dynamic and collaborative",
    resumeLink:'https://drive.google.com/file/d/1vfnzDcN4uATaNZ7cc9kdKvep9ZBUN_be/view?usp=sharing',
    imageUrl:''
}
export const autoTypeData=['3rd Year IT Grad', 'MERN Stack Developer','Flutter App Developer', 'Open Source Contributor'];
export default PersonalData;
